import { connect } from 'react-redux';
import { activate as activateContract } from 'insurance/insuranceContracts/actions';
import { find as findPurchase } from 'billing/purchases/actions';
import InsurancePurchase from './InsurancePurchase';

const mapDispatchToProps = {
  activateContract,
  findPurchase,
}

export default connect(
  null,
  mapDispatchToProps
)(InsurancePurchase);
